import axios from "axios";
import { connect } from 'react-redux';
import React, { Component } from 'react';
import { default as VFormTree } from '../components/FormTree/FormTree';
import {
// properties
    APP_URL
// reducer names
   ,DOC
} from '../redux/constants';
import {
    setPropValue
} from '../redux/actions/utils';
import {
    setDocId
   ,setGroupId
} from '../redux/actions/admin';


class FormTree extends Component {

    componentDidMount() {
        this.props.onStart();
    }
    
    render() {
        return <VFormTree {...this.props} />;
    }
}


const mapStateToProps = ( { doc } ) => {
    return {
        doc
    };
}


const mapDispatchToProps = dispatch => ({
    onCloseFormTree: () => {
        dispatch( setPropValue( DOC, 'showFormTree', false ) );
    }
   ,onStart: () => {
        getForm( dispatch ); // show root folders
    }
   ,onFind: ( e ) => {
        const name = e.target.value;
        if( name === '' )
            getForm( dispatch );
        else
            findForm( dispatch, name );
    }
   ,onNodeSelect: ( e, tyid ) => {
        if( !tyid ) return;
        if( tyid.charAt(0) === "F" ) {
            const docState = dispatch( ( dispatch, getState ) => getState().doc )
            const groupId = docState.groupId;
            const docId = docState.docId;
            const formTree = docState.formTree;
            if( !Array.isArray( formTree ) ) return;
            const item = formTree.find( i => i.tyid === tyid );
            if( item === undefined ) return;
            const newGroupId = Number( item.parent_id );
            const newDocId = Number( item.id );
            if( groupId !== newGroupId ) setGroupId( dispatch, newGroupId );
            if( docId !== newDocId ) setDocId( dispatch, newDocId );
        } else
            getForm( dispatch, tyid.substring(1) );
    }
});


function getForm( dispatch, id = '' ) {
    request( dispatch, "get", { id } );
}

function findForm( dispatch, name ) {
    request( dispatch, "find", { name } );
}

let controller;
function request( dispatch, method, params ) {

    if( controller ) {
        controller.abort();
    }
    
    controller = new AbortController();
    const { signal } = controller;
    
    axios.get( APP_URL + '/api/formtree/' + method, {
        params,
        signal: signal
    })
    .then(response => {
        const data = response.data;
        if( !Array.isArray( data ) ) return;
        data.forEach( i => { i.tyid = i.type + i.id } ); // G123 или F123 для группы и формы, потому что id групп и форм могут пересекаться
        dispatch( setPropValue( DOC, 'formTree', response.data ) );
    })
   .catch(error => {
        if( axios.isCancel( error ) )
            console.log('Запрос отменен', error.message);
        else
            console.error('Ошибка запроса', error);
    });

}


export default connect( mapStateToProps, mapDispatchToProps )( FormTree );
